
<div
    class="CommentWrap"
    :class="[
        { 'is-disabled': isDisabled },
        { 'has-error': error && error.length > 0 },
        `is-${direction}`,
    ]"
    :style="style"
>
    <div v-if="showAddForm" class="CommentForm">
        <textarea
            ref="commentTextarea"
            class="CommentInput"
            v-model="newCommentText"
            :placeholder="placeholder"
            :disabled="isDisabled"
            rows="3"
            @keyup.ctrl.enter="handleSaveComment"
        ></textarea>
        <div class="CommentActions">
            <Button variant="plain" size="small" @onClick="handleCancelComment">
                Abbrechen
            </Button>
            <Button
                size="small"
                :is-disabled="!newCommentText.trim() || isSubmitting"
                :is-loading="isSubmitting"
                @onClick="handleSaveComment"
            >
                {{ editingComment ? 'Aktualisieren' : 'Hinzufügen' }}
            </Button>
        </div>
    </div>

    <div v-if="isLoading" class="LoadingState">
        <div class="LoadingSpinner">Laden...</div>
    </div>

    <div v-else-if="comments.length > 0" class="CommentsList">
        <div
            v-for="comment in comments"
            :key="comment.id"
            class="CommentItem"
            :class="{ 'is-editing': editingComment && editingComment.id === comment.id }"
        >
            <div class="CommentHeader">
                <span class="CommentDate">{{ formatDate(comment.createdAt) }}</span>
                <div v-if="!isDisabled" class="CommentControls">
                    <Button
                        variant="icon"
                        size="small"
                        @onClick="() => handleEditComment(comment)"
                    >
                        <i class="ri-edit-line" style="font-size: 1rem"></i>
                    </Button>
                    <Button
                        variant="icon"
                        size="small"
                        @onClick="() => handleDeleteComment(comment)"
                    >
                        <i class="ri-delete-bin-line" style="font-size: 1rem"></i>
                    </Button>
                </div>
            </div>
            <div class="CommentContent">{{ comment.message }}</div>
            <div
                v-if="comment.updatedAt && comment.updatedAt !== comment.createdAt"
                class="CommentUpdated"
            >
                Zuletzt aktualisiert: {{ formatDate(comment.updatedAt) }}
            </div>
        </div>
    </div>

    <div v-else-if="comments.length === 0 && !showAddForm && !isLoading" class="EmptyState">
        <span class="EmptyStateText">Noch keine Kommentare</span>
    </div>

    <div v-if="!showAddForm && !isDisabled" class="AddCommentButton">
        <Button size="small" @onClick="showAddCommentForm">
            <template #iconBefore>
                <i class="ri-add-line"></i>
            </template>
            Kommentar hinzufügen
        </Button>
    </div>

    <span v-if="error && error.length > 0" class="Error">{{ error }}</span>
</div>
